<template>
  <CoolLightBox
    :closeOnClickOutsideMobile="true"
    :enableScrollLock="false"
    v-bind="$attrs"
    @on-change="$emit('on-change', $event)"
    @on-open="onOpen($event)"
    @close="onClose($event)">
  </CoolLightBox>
</template>

<script>

  const CoolLightBox = () => {
    import(/* webpackChunkName: "vue-cool-lightbox" */ 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css')
    return import(/* webpackChunkName: "vue-cool-lightbox" */ 'vue-cool-lightbox')
  }
 
  export default {
    components: {
      CoolLightBox
    },
    data() {
      return {
        scrollWidth: 0
      }
    },
    mounted() {
      this.scrollWidth = (window.innerWidth - document.documentElement.clientWidth) || parseFloat(getComputedStyle(document.documentElement).paddingRight) || 0
    },
    methods: {
      onOpen(event) {
        document.documentElement.style.overflowY = 'hidden'
        document.querySelector('body').style.overflow = null;
        document.documentElement.style.paddingRight = this.scrollWidth + 'px'
        document.querySelector('.page-header__inner').style.paddingRight = this.scrollWidth + 'px'
        this.$emit('on-open', event)
      },
      unBlockScroll() {
        document.documentElement.style.overflowY = null
        document.documentElement.style.paddingRight = null
        document.querySelector('.page-header__inner').style.paddingRight = null
      },
      onClose(event) {
        this.$emit('close', event)
        setTimeout(this.unBlockScroll, 300)
      },
    }
  }
</script>

<style lang="less">

</style>
